module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/shuffle-efab9d1a0e1dc03f7ae36088ee6c7ea0.svg";